<label class="card-selectable mb-0 h-100" [attr.for]="inputID()">
  <div class="row gx-2">
    <div class="col">
      <ng-content />
    </div>
    <div class="col-auto">
      <input
        data-test="mwe-card-selectable-checkbox"
        [attr.id]="inputID()"
        [ngClass]="{
          'is-invalid': isInvalid(),
        }"
        [disabled]="disabled()"
        class="form-check-input"
        type="checkbox"
        [checked]="isSelected()"
        (click)="toggle()"
        [attr.aria-invalid]="isInvalid()"
      />
    </div>
  </div>
</label>
